/*-
 * #%L
 * Aires Éducatives
 * %%
 * Copyright (C) 2020 - 2023 OFB
 * %%
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 * #L%
 */
import i18n from "@/i18n"

/**
 * Utilitaires pour l'internationalisation (i18n)
 * Ces fonctions permettent d'utiliser Vue I18n en dehors des composants Vue
 * en évitant les problèmes de typage TypeScript complexes
 */

/**
 * Fonction de traduction simple
 * @param key - Clé de traduction
 * @param params - Paramètres de traduction optionnels
 * @returns La traduction en tant que chaîne
 */
export const t = (key: string, params?: any): string => {
  return String((i18n.global as any).t(key, params))
}

/**
 * Teste si une clé de traduction existe
 * @param key - Clé de traduction à tester
 * @returns true si la clé existe, false sinon
 */
export const te = (key: string): boolean => {
  return (i18n.global as any).te(key)
}

/**
 * Obtient toutes les locales disponibles
 * @returns Array des locales disponibles
 */
export const getAvailableLocales = (): string[] => {
  return i18n.global.availableLocales
}

/**
 * Alias pour la fonction de traduction (plus court)
 */
export const translate = t

/**
 * Export par défaut de la fonction de traduction principale
 */
export default t
